const HiddenComposer = () => {
  return null;
};

export default HiddenComposer;
